import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RespuestasEvaluacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RespuestasEvaluacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRespuestasEvaluacionService(): Observable<BodyListResponse<RespuestasEvaluacionDTO>> {
    return this.http.get<BodyListResponse<RespuestasEvaluacionDTO>>(API_URL + '/api/v1/respuestasEvaluacion/todos');
  }

  guardarRespuestasEvaluacionService(respuestasEvaluacionDTO: RespuestasEvaluacionDTO): Observable<BodyResponse<RespuestasEvaluacionDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/respuestasEvaluacion', respuestasEvaluacionDTO);
  }

  getRespuestasEvaluacionPorCodigoService(codigo: string): Observable<BodyResponse<RespuestasEvaluacionDTO>> {
    return this.http.get<BodyResponse<RespuestasEvaluacionDTO>>(API_URL + '/api/v1/respuestasEvaluacion/' + codigo);
  }

  getRespuestasEvaluacionPorPreguntaService(codigo: string): Observable<BodyListResponse<RespuestasEvaluacionDTO>> {
    return this.http.get<BodyListResponse<RespuestasEvaluacionDTO>>(API_URL + '/api/v1/respuestasEvaluacion/pregunta/' + codigo);
  }
}


